import React from "react";
import { Button, Image } from "semantic-ui-react";
import { dispatch } from "@rematch/core";
import { withRouter } from "react-router-dom";
import { source } from "react-aim";
import CommonTable from "../../../../drive/Table/TableLayout";
import OrgUsersListViewJSON from "./OrgUsersListViewJSON.json";
import TeamUsersListViewJSON from "./TeamUsersListViewJSON.json";
import OrgUsersListViewManagerJSON from "./OrgUsersListViewManagerJSON.json";
import InvitationListView from "./InvitationListView";
import noInvite from "./../../../../../images/grafix-banner/undraw_hire.svg";
import { truncate } from "lodash";
import ChangeRoleModel from "../modals/ChangeRoleModel";
import RemoveUserFromWorkspace from "../modals/RemoveUserFromWorkspace";
import DeleteUserFromUnit from "../modals/DeleteUserFromUnit";
let timer = 0;
let delay = 200;
let prevent = false;

@source({
  mouseEnter: (props, component) => {
    dispatch.app.setHelpContext(props.name);
  },
})
class UsersListView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableHeader: [],
      listData: "",
      totalDataCount: this.props.usersList.length,
      _limit: 10,
      _sort: "firstName",
    };
  }

  
  componentWillMount() {
    dispatch.lifeCycle.setLibraryCardIndex(null);
    dispatch.organizationUnit.showDeleteDisabled(false);
    
    

    let setHeader =
      this.props.match.params.workspaceId === this.props.match.params.teamId &&
      this.props.selectedOrganisation.role === "workspaceOwner"
        ? OrgUsersListViewJSON
        : this.props.selectedOrganisation.id ===
            this.props.match.params.teamId &&
          this.props.selectedOrganisation.role === "Manager"
        ? OrgUsersListViewManagerJSON
        : TeamUsersListViewJSON;

    this.setState({ tableHeader: setHeader });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.usersList !== nextProps.usersList) {

      this.setState({
        listData: nextProps.usersList,
        totalDataCount: nextProps.usersList && nextProps.usersList.length,
      })
    }
  }
  
  redirectUserInvite() {
    const { history } = this.props;
    history.push(
      `/app/${this.props.selectedAccount._id}/_ws/${
        this.props.selectedOrganisation.id
      }/_cm/addUser/addUserInUserList/${
        this.props.selectedSubOrg
          ? this.props.selectedSubOrg._id
          : this.props.selectedOrganisation.id
      }/${
        this.props.selectedSubOrg &&
        this.props.selectedSubOrg.parentOrganizationId
          ? this.props.selectedSubOrg.parentOrganizationId
          : this.props.selectedOrganisation.id
      }`
    );
  }

  handleClick(event, user, index) {
    let thisClick = this;
    timer = setTimeout(function () {
      if (!prevent) {
        thisClick.cardClick(user, index);
      }
      prevent = false;
    }, delay);
  }

  async cardClick(user, index) {
    console.log("here");
    dispatch.users.updateState(user);
    dispatch.community.addMainAreaContext("USERS");
    dispatch.organizationUnit.showResourecePane("User");
    if (
      this.props.match.params.teamId.toString() ===
      this.props.selectedOrganisation.id.toString()
    ) {
      const userRoleArray = this.props.selectedOrganisation.users.filter(
        function (user) {
          return user.role === "workspaceOwner";
        }
      );

      if (
        (this.props.user._id.toString() === user._id.toString() ||
        (userRoleArray.length < 2 && user.role === "workspaceOwner") ||
        this.props.selectedOrganisation.role !== "workspaceOwner") && (this.props.user._id === user._id  )
      ) {
        dispatch.organizationUnit.showDeleteDisabled(false);
      } else {
        dispatch.organizationUnit.showDeleteDisabled(true);
      }
    } else {
      const userRoleArray = this.props.selectedSubOrg.members.filter(function (
        user
      ) {
        return user.role === "Manager";
      });

      if (userRoleArray.length < 1 && user.role === "Manager") {
        dispatch.organizationUnit.showDeleteDisabled(false);
      } else {
        dispatch.organizationUnit.showDeleteDisabled(true);
      }
    }
    dispatch.lifeCycle.splitAt("60%");
    dispatch.lifeCycle.setLibraryCardIndex(index);
    dispatch.app.setCollapsedResourcePaneIndexTemp(null);
    dispatch.users.userDeactivateModal(false);
  }

  handleDoubleClick(user, index) {
    clearTimeout(timer);
    prevent = true;
    this.doDoubleClickAction(user, index);
  }

  doDoubleClickAction(user, index) {
    this.cardClick(user, index);
    dispatch.lifeCycle.splitAt("60%");
  }
  async handleClickUserDetailsPage(event, user) {
    event.stopPropagation();
    await dispatch.users.updateState(user);
    await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
    await dispatch.organizationUnit.showResourecePane(null);
    let ops = "Add Sub-Team";
    dispatch.community.addBreadCrumbOps(ops);
    this.props.history.push({
      pathname: `/app/${this.props.selectedAccount._id}/_ws/${
        this.props.selectedOrganisation.id
      }/_cm/userDetail/${
        this.props.selectedSubOrg
          ? this.props.selectedSubOrg._id
          : this.props.selectedOrganisation.id
      }/${this.props.match.params.userType}/${user._id}`,
    });
  }

  disabledMenus(usersList, currentOrganization) {
    if (usersList && usersList.length > 0) {
      for (let i = 0; i < usersList.length; i++) {
        let d = usersList[i];
        let isSubOrgMember = this.props.selectedSubOrg && this.props.selectedSubOrg.members && this.props.selectedSubOrg.members.some(el=>el.accountUserId === d._id &&  el.role==="Manager");
        let found = currentOrganization.some(el=>el.accountUserId === d._id &&  el.role==="workspaceOwner")
        if (found && isSubOrgMember) {
           d.isChangeRoleAccess = true;
        } else {
          d.isChangeRoleAccess = false;
        }
        if(d.role === "workspaceOwner"){
          d.isChangeRoleAccess = true
        }
        if(d.role === "Manager" && this.props.selectedOrganisation.role === "Manager"){
          d.isChangeRoleAccess = true
        }
        d.isDeleteAccess = !(!this.props.isDeleteDisabled || this.props.collapsedResourcePaneIndexTemp === 0 || (this.props.selectedOrganisation.role === 'Manager' && this.props.orgUniqueId === this.props.selectedOrganisation.id) || (d && this.props.selectedAccount && this.props.selectedAccount.users && this.props.selectedAccount.users.length > 0 && this.props.selectedAccount.users.some(user => user.id && user.id._id && d._id && user.id._id.toString() === d._id.toString() && user.role === 'customerAdmin') && this.props.orgUniqueId === this.props.selectedOrganisation.id))
      }
    }
  }
  addColumn = (newColumns) => {
    if (newColumns) {
      this.setState({ tableHeader: newColumns });
    }
  };
  handleTableComponent = (event, item, data) => {};
  handleDropDownItem = (event, type, data, clickedCount) => {
    if (type.text === "Details") {
      this.handleClickUserDetailsPage(event, data);
    }
    if (type.text === "View") {
      this.handleClick(event, data);
    }
    if (type.text === "Change Role") {
      this.setState({ open: true, userdata: data });
      // this.handleChangeRole(event, data)
    }
    if (type.text === "Delete") {
      dispatch.users.updateState(data);
      if (this.props.orgUniqueId.toString() === this.props.selectedOrganisation.id.toString()) {
          let payload = {};
          payload.accountUserId = data._id;
          payload.organisationId = this.props.selectedOrganisation.id;
          payload.subOrgId = this.props.orgUniqueId;
          dispatch.users.getdeactivateuserdetails(payload)
          dispatch.users.userDeactivateModal(true);
      } else {
          let deletesuborgObj = Object.assign({}, data);
          deletesuborgObj.role = data.role;
          deletesuborgObj.subOrgName = this.props.selectedSubOrg.name;
          deletesuborgObj.subOrgId = this.props.selectedSubOrg._id;
          deletesuborgObj.type = 'deleteUserFromToolbar';
          deletesuborgObj.organisation = this.props.selectedSubOrg.name;
          dispatch.users.addUserToDelete(deletesuborgObj);
          dispatch.users.userDelModalOpen(true);
      }
      // this.handleChangeRole(event, data)
    }
  };
  changeRole = (open) => {
    this.setState({ open: open });
  };

  showRole(role) {
    let items = Object.assign(this.state.tableHeader);
    if (this.state.tableHeader && role === "users") {
      items[1].listed = true;
    } else {
      items[1].listed = false;
    }
    this.setState({ tableHeader: items });
  }

  componentWillReceiveProps(nextProps) {
    

    // this.showRole(nextProps.match.params.userType);
    if (nextProps.match.params.userType === "users") {
      this.setState({
        listData: nextProps.usersList,
        totalDataCount: nextProps.usersList.length,
      });
    } else if (nextProps.match.params.userType === "Manager") {
      this.setState({
        listData: nextProps.managerList,
        totalDataCount: nextProps.managerList.length,
      });
      //dispatch.users.setUsersListData(nextProps.managerList);
    } else if (nextProps.match.params.userType === "Member") {
      this.setState({
        listData: nextProps.memberList,
        totalDataCount: nextProps.memberList.length,
      });
      // dispatch.users.setUsersListData(nextProps.memberList);
    } else if (nextProps.match.params.userType === "workspaceOwner") {
      this.setState({
        listData: nextProps.executiveList,
        totalDataCount: nextProps.executiveList.length,
      });
      //dispatch.users.setUsersListData(nextProps.executiveList);
    }
    if (nextProps.usersList.length>0 && nextProps.currentOrganization) {
      this.disabledMenus(nextProps.usersList,nextProps.currentOrganization.users );
    }
    
  }

  render() {
    return (
      <div>
        {this.props.match.params.userType === "Invitations" ? (
          <InvitationListView {...this.props} />
        ) : this.props.usersList && this.props.usersList.length === 0 ? (
          <div className="w_50 text-center mar_0_auto pad_20">
            <Image src={noInvite} /> <br />
            <strong as="h3"> No users to display.</strong>
            <br />
            <br />
            <strong>
              {" "}
              Communities are all about communicating, <br /> Collaborating and
              Managing. Start creating your <br />
              own teams.
            </strong>
            <br />
            <br />
            <Button
              className="button-submit"
              onClick={(e) => this.redirectUserInvite(e)}
            >
              Add / Invite Users
            </Button>
          </div>
        ) : (
          <CommonTable
            tableHeader={this.state.tableHeader}
            listData={this.state.listData}
            searchable={false}
            selection={true}
            totalCount={this.state.totalDataCount}
            loading={this.props.worspacesLoading}
            //onQueryChange={this.onQueryChange}
            limit={this.state._limit}
            sort={this.state._sort}
            filterHeader={true}
            addColumn={this.addColumn}
            handleDropDownItem={this.handleDropDownItem}
            handleTableComponent={this.handleTableComponent}
          />
        )}

        {/* //change role model */}
        <ChangeRoleModel
          open={this.state.open}
          changeRole={this.changeRole}
          selectedOrganisation={this.props.selectedOrganisation}
          userdata={this.state.userdata}
          teamId={this.props.match.params.teamId}
          currprops={this.props}
        />
        {this.props.isUserDeactivateModal ?
                    <RemoveUserFromWorkspace {...this.props} /> : ''}

        {this.props.userDelModalOpen ?
            <DeleteUserFromUnit
                selectedOrganisation={this.props.selectedOrganisation}
                selectedAccount={this.props.selectedAccount}
                userToDel={this.props.userToDel}
                selectedTeamName={this.props.userToDel.subOrgName}
                userDelModalOpen={this.props.userDelModalOpen}
                userObj={this.props.userObj}
                usersList={this.props.usersList}
            />
            : ''}
      </div>
    );
  }
}

export default withRouter(UsersListView);
